// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__285bi","topBottomGutter":"Layout_topBottomGutter__wSt-O"};